export const httpService = {
  get(endpoint: string, data = {}) {
    return ajax(endpoint, "GET", data);
  },
  post(endpoint: string, data = {}) {
    return ajax(endpoint, "POST", data);
  },
  put(endpoint: string, data = {}) {
    return ajax(endpoint, "PUT", data);
  },
  delete(endpoint: string, data = {}) {
    return ajax(endpoint, "DELETE", data);
  },
  graphql(companyName: string, query: string | { query: string, variables: { [key: string]: any } }) {
    if (typeof query === 'string') {
      const reqBody = {
        company_name: companyName,
        query
      }
      return this.post("/graphql", reqBody);
    }

    const reqBody = {
      company_name: companyName,
      ...query
    }
    return this.post("/graphql", reqBody);
  },
  getURL,
  getAccessToken,
};

async function ajax(
  endpoint: string,
  method = "GET",
  data: { [key: string]: any }
) {
  try {
    const url = getURL(endpoint);
    const access_token = getAccessToken();
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    if (method === "GET") {
      const urlSearchParams = new URLSearchParams();
      for (const [key, value] of Object.entries(data))
        urlSearchParams.set(key, value);
      const rawResponse = await fetch(`${url}?${urlSearchParams}`, { headers });
      if (!rawResponse.ok) throw rawResponse;
      return rawResponse.json();
    }

    const rawResponse = await fetch(url, {
      method,
      headers,
      body: JSON.stringify(data),
    });
    if (!rawResponse.ok) throw rawResponse;
    if (rawResponse.headers.get("Content-Type") === "text/plain")
      return rawResponse.text();
    return rawResponse.json();
  } catch (err) {
    console.log(
      `Had Issues ${method}ing to the backend, endpoint: ${endpoint}, with data: ${JSON.stringify(
        data
      )}`
    );
    console.dir(err);
    throw err;
  }
}

function getURL(endpoint: string) {
  console.log(new URL(endpoint, process.env.REACT_APP_BACKEND_URL).href)
  return new URL(endpoint, process.env.REACT_APP_BACKEND_URL).href;
}

function getAccessToken() {
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i)!;
    if (key.endsWith("accessToken")) {
      const token = localStorage.getItem(key);
      if (token) return token;
    }
  }
}
